import { render } from "./CumvRupe.vue?vue&type=template&id=1e8b2921"
const script = {}

import "./CumvRupe.vue?vue&type=style&index=0&id=1e8b2921&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__